import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import RouteConstants from '@/features/router/RouteConstants';
import { CongratulationScreen } from '@/global/components/CongratulationScreen';

export const AudienceDestinationSyncSuccessful: FC = () => {
  const history = useHistory();

  const handleCloseClick = () => {
    history.replace(RouteConstants.home);
  };

  return (
    <CongratulationScreen
      title='ALL:destinations.steps.confirm.audienceDestinationSyncedSuccesfully'
      subtitle='ALL:destinations.steps.confirm.readyToCreateAnotherDestination'
      secondaryButton={{
        text: 'COMMON:goBack',
        onClick: handleCloseClick,
      }}
    />
  );
};
